import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class MedicalFromService {

  constructor(private http: HttpClient) { }

  addMedicalRecord(data: any): Observable<any> {
    console.log("Adding clients", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "medical/save", data).subscribe((res: any) => {

        observer.next(res.data.client);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  updateMedicalRecord(data: any): Observable<any> {
    console.log("updating record", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "medical/edit", data).subscribe((res: any) => {

        observer.next(res.data.client);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  updateStatus(data: any): Observable<any> {
    console.log("updating record", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "medical/update-status", data).subscribe((res: any) => {

        observer.next(res.data.client);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  getMedicalRecord(id): Observable<any> {
    console.log("Getting Medical Record");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "medical/get?userId=" + id).subscribe((res: any) => {
        console.log("Get RECORD : ", res);
        observer.next(res.data);
        observer.complete();
      })

    });
  }

  downloadMedicalpdf(data: any): Observable<any> {
    console.log("medical pdf download:", data);

    return new Observable<any>((observer) => {
      console.log("medical pdf download")
      console.log("Observable");
      let that = this;
      this.http.post(config.baseApiUrl + "medical/download", data).subscribe((res: any) => {
        observer.next(res.data);
      }, err => {
        console.log("ERROR ", err)
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })

    });

  }

  downloadAllMedicalpdf(data: any): Observable<any> {
    console.log("medical pdf download:", data);

    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.get(config.baseApiUrl + "medical/download-all/" + data).subscribe((res: any) => {
        console.log(" res ", res)
        observer.next(res);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }

  checkEmail(data: any): Observable<any> {
    console.log("Adding clients", data);
    // let email = JSON
    return new Observable<any>((observer) => {
      console.log("Observable");
      let obj = {
        email: data
      }
      let that = this;
      this.http.put(config.baseApiUrl + "medical/check-email", obj).subscribe((res: any) => {
        console.log("response of email check=", res);

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          // observer.complete();
        })

    });

  }



  sendClientMail(data: any): Observable<any> {
    console.log("Adding clients", data);
    // let email = JSON
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "medical/client-mail", data).subscribe((res: any) => {
        console.log("response of email check=", res);

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          // observer.complete();
        })

    });

  }

  updateResult(resultsArray): Observable<any> {
    console.log("Updating Result...", resultsArray);
    // let email = JSON
    return new Observable<any>((observer) => {
      console.log("Observable");
      let that = this;
      this.http.put(config.baseApiUrl + "medical/update-result", resultsArray).subscribe((res: any) => {
        console.log("response of update Result =", res);

        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          // observer.complete();
        })

    });
  }

}
